/* global axios */

import ApiClient from './ApiClient';

class IntegrationsAPI extends ApiClient {
  constructor() {
    super('integrations/apps', { accountScoped: true });
  }

  connectSlack(code) {
    return axios.post(`${this.baseUrl()}/integrations/slack`, { code });
  }

  updateSlack({ referenceId }) {
    return axios.patch(`${this.baseUrl()}/integrations/slack`, {
      reference_id: referenceId,
    });
  }

  listAllSlackChannels() {
    return axios.get(`${this.baseUrl()}/integrations/slack/list_all_channels`);
  }

  delete(integrationId) {
    return axios.delete(`${this.baseUrl()}/integrations/${integrationId}`);
  }

  createHook(hookData) {
    return axios.post(`${this.baseUrl()}/integrations/hooks`, hookData);
  }

  deleteHook(hookId) {
    return axios.delete(`${this.baseUrl()}/integrations/hooks/${hookId}`);
  }

  generateWeChatAuthorization(payload) {
    return axios.post(
      `${this.baseUrl()}/integrations/wechat/wechat_auth`,
      payload
    );
  }

  checkWeChatAuthorizationStatus(authCode) {
    const params = {};
    if (authCode) {
      params.auth_code = authCode;
    }
    return axios.get(
      `${this.baseUrl()}/integrations/wechat/wechat_auth_status`,
      { params }
    );
  }

  generateWeChatCompanyQRCode(payload) {
    return axios.post(
      `${this.baseUrl()}/integrations/wecom/get_app_qrcode`,
      payload
    );
  }

  checkWeChatCompanyAuthorizationStatus(authCode) {
    const params = {};
    if (authCode) {
      params.auth_code = authCode;
    }
    return axios.get(`${this.baseUrl()}/integrations/wecom/auth_status`, {
      params,
    });
  }
}

export default new IntegrationsAPI();
